/**
 * `@microsoft/voice-widget-embed/provider-neutral` — defines `<voice-agent>` and exports
 * the supported UI/registry API, but bundles no provider. Load your own provider
 * package alongside it; it registers through the same registry this entry exposes.
 *
 * `index.ts` is this module plus one side-effect import of the built-in provider, so the
 * only difference between the two published entries stays visible as a single line.
 */
import { register } from "./element";

export { register, TAG_NAME, VoiceAgentElement } from "./element";
export { parseAttributes } from "./attributes";
export { mountVoiceAgent } from "@microsoft/voice-widget-ui";
export {
  registerProvider,
  createProvider,
  hasProvider,
  listProviders,
  onProviderRegistered,
} from "@microsoft/voice-widget-core-client";
export type { MountVoiceAgentOptions, VoiceAgentController } from "@microsoft/voice-widget-ui";
export type { VoiceAgentEventMap } from "./events.js";
export type {
  VoiceAgentTelemetryEvent,
  TelemetryEnvelope,
  TelemetryAttemptStatus,
  TelemetryStage,
  BrokerEndpoint,
} from "@microsoft/voice-widget";

// Auto-register for the <script> one-liner (harmless when imported as ESM).
register();
